export const userInfo = (state) => {
    return state.userInfo
}

export const maintenance = (state) => {
    return state.maintenance
}

export const environment = (state) => {
    return state.forcedEnv || state.defaultEnv
}

export default {
    userInfo,
    maintenance,
    environment
}
